export default {
  text: 'black',
  primary: '#026747',
  secondary: '#ffbc16',
  tertiary: '#cd0f28',
  quaternary: '#fa5235',
  background: '#fff6ed',
  backgroundSecondary: '#33cbc9',
  light: '#FFF',
  dark: '#black'
}
